import React from 'react'


// Color Palette from instructions
const COLORS = {
    primary: "#E76F51",      // Warm NGO Red
    secondary: "#F4A261",    // Soft Orange
    accent: "#E9C46A",       // Warm Yellow
    background: "#FDF6EC",   // Light Beige
    surface: "#FFFFFF",      // Card Color
    textPrimary: "#2D2D2D",
    textSecondary: "#6B6B6B"
  };


const InternshiForm = () => {
  return (
   <section
      className="py-20 pt-32  px-4 md:px-20 "
      style={{ backgroundColor: COLORS.background }}
    >
      {/* Header */}
      <div className="mt-4 mx-auto px-4 md:px-6 max-w-7xl ">
        <h1
          className="text-4xl md:text-5xl font-bold mb-4 font-serif"
          style={{ color: COLORS.primary }}
        >
          Internship Registration Form – The Vanrang Foundation
        </h1>
        <div className="font-medium mb-3" style={{ color: COLORS.textSecondary }}>
          Thank you for your interest in joining The Vanrang Foundation as an intern.
        </div>
        <div className="mb-2" style={{ color: COLORS.textSecondary, fontSize: 16 }}>
          We are a Section 8 non-profit organization registered under the Ministry of Corporate Affairs, Government of India, working towards social impact and youth development across India.
        </div>
        <div style={{ color: COLORS.textSecondary, fontSize: 15 }}>
          Please fill out this form carefully. All information will remain confidential and used only for official purposes.
        </div>
      </div>

      {/* RIGHT FORM */}
      <div
        className="rounded-2xl shadow-lg p-10 border-t-8 mx-auto px-4 md:px-6 max-w-7xl mt-20"
        style={{
          backgroundColor: COLORS.surface,
          borderTopColor: COLORS.primary
        }}
      >
        <h2
          className="text-2xl font-bold mb-6 text-center font-serif"
          style={{ color: COLORS.primary }}
        >
          Internship Registration Form
        </h2>

        <form className="space-y-5">
          {/* Full Name */}
          <div>
            <label className="block font-semibold mb-1" style={{ color: COLORS.textPrimary }}>
              Full Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              required
              className="rounded-lg p-3 w-full outline-none"
              placeholder="Enter your Full Name"
              style={{
                border: `1.5px solid ${COLORS.accent}`,
                color: COLORS.textPrimary
              }}
            />
          </div>
          {/* Mobile Number */}
          <div>
            <label className="block font-semibold mb-1" style={{ color: COLORS.textPrimary }}>
              Mobile Number <span className="text-red-500">*</span>
            </label>
            <input
              type="tel"
              required
              className="rounded-lg p-3 w-full outline-none"
              placeholder="Enter your Mobile Number"
              style={{
                border: `1.5px solid ${COLORS.accent}`,
                color: COLORS.textPrimary
              }}
            />
          </div>
          {/* Email ID */}
          <div>
            <label className="block font-semibold mb-1" style={{ color: COLORS.textPrimary }}>
              Email ID <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              required
              className="rounded-lg p-3 w-full outline-none"
              placeholder="Enter your Email"
              style={{
                border: `1.5px solid ${COLORS.accent}`,
                color: COLORS.textPrimary
              }}
            />
          </div>
          {/* Date of Birth & Date */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block font-semibold mb-1" style={{ color: COLORS.textPrimary }}>
                Date of Birth <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                required
                className="rounded-lg p-3 w-full outline-none"
                style={{
                  border: `1.5px solid ${COLORS.accent}`,
                  color: COLORS.textPrimary
                }}
              />
            </div>
            <div>
              <label className="block font-semibold mb-1" style={{ color: COLORS.textPrimary }}>
                Date
              </label>
              <input
                type="date"
                className="rounded-lg p-3 w-full outline-none"
                style={{
                  border: `1.5px solid ${COLORS.accent}`,
                  color: COLORS.textPrimary
                }}
              />
            </div>
          </div>
          {/* Gender */}
          <div>
            <label className="block font-semibold mb-2" style={{ color: COLORS.textPrimary }}>
              Gender <span className="text-red-500">*</span>
            </label>
            <div className="flex flex-wrap gap-6 items-center">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="gender"
                  required
                  value="Male"
                  className="accent-orange-600"
                />
                Male
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="gender"
                  value="Female"
                  className="accent-orange-600"
                />
                Female
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="gender"
                  value="Prefer not to say"
                  className="accent-orange-600"
                />
                Prefer not to say
              </label>
            </div>
          </div>
          {/* College / University Name */}
          <div>
            <label className="block font-semibold mb-1" style={{ color: COLORS.textPrimary }}>
              College / University Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              required
              className="rounded-lg p-3 w-full outline-none"
              placeholder="Enter College or University Name"
              style={{
                border: `1.5px solid ${COLORS.accent}`,
                color: COLORS.textPrimary
              }}
            />
          </div>
          {/* Course */}
          <div>
            <label className="block font-semibold mb-1" style={{ color: COLORS.textPrimary }}>
              Course (B.A, BBA, etc.) <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              required
              className="rounded-lg p-3 w-full outline-none"
              placeholder="Course (B.A, BBA, etc.)"
              style={{
                border: `1.5px solid ${COLORS.accent}`,
                color: COLORS.textPrimary
              }}
            />
          </div>
          {/* Year */}
          <div>
            <label className="block font-semibold mb-1" style={{ color: COLORS.textPrimary }}>
              Year (1st / 2nd / Final) <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              required
              className="rounded-lg p-3 w-full outline-none"
              placeholder="Year (e.g., 1st, 2nd, Final)"
              style={{
                border: `1.5px solid ${COLORS.accent}`,
                color: COLORS.textPrimary
              }}
            />
          </div>
          {/* Preferred Internship Duration */}
          <div>
            <label className="block font-semibold mb-1" style={{ color: COLORS.textPrimary }}>
              Preferred Internship Duration <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              required
              className="rounded-lg p-3 w-full outline-none"
              placeholder="e.g. 1 month, 2 months"
              style={{
                border: `1.5px solid ${COLORS.accent}`,
                color: COLORS.textPrimary
              }}
            />
          </div>
          {/* Field of Interest */}
          <div>
            <label className="block font-semibold mb-1" style={{ color: COLORS.textPrimary }}>
              क्षेत्र / Field of Interest <span className="text-red-500">*</span>
            </label>
            <div className="flex flex-wrap gap-6 items-center">
              <label className="flex items-center gap-2">
                <input type="checkbox" name="field" value="Marketing / Social Media" required className="accent-orange-600" />
                Marketing / Social Media
              </label>
              <label className="flex items-center gap-2">
                <input type="checkbox" name="field" value="Event Management" className="accent-orange-600" />
                Event Management
              </label>
              <label className="flex items-center gap-2">
                <input type="checkbox" name="field" value="Awareness Campaign" className="accent-orange-600" />
                Awareness Campaign
              </label>
              <label className="flex items-center gap-2">
                <input type="checkbox" name="field" value="Content Writing / Copywriting" className="accent-orange-600" />
                Content Writing / Copywriting
              </label>
              <label className="flex items-center gap-2">
                <input type="checkbox" name="field" value="Graphic Designing / Poster Making" className="accent-orange-600" />
                Graphic Designing / Poster Making
              </label>
              <label className="flex items-center gap-2">
                <input type="checkbox" name="field" value="Fundraising / Sponsorship" className="accent-orange-600" />
                Fundraising / Sponsorship
              </label>
              <label className="flex items-center gap-2">
                <input type="checkbox" name="field" value="Team Coordination / Leadership" className="accent-orange-600" />
                Team Coordination / Leadership
              </label>
              <label className="flex items-center gap-2">
                <input type="checkbox" name="field" value="Environmental Activities" className="accent-orange-600" />
                Environmental Activities (Plantation, Clean Drives)
              </label>
              <label className="flex items-center gap-2">
                <input type="checkbox" name="field" value="Video Editing / Reels Creation" className="accent-orange-600" />
                Video Editing / Reels Creation
              </label>
              <label className="flex items-center gap-2">
                <input type="checkbox" name="field" value="Other" className="accent-orange-600" />
                Other
              </label>
            </div>
          </div>
          {/* Why do you want to do internship? */}
          <div>
            <label className="block font-semibold mb-1" style={{ color: COLORS.textPrimary }}>
              आप internship क्यों करना चाहते हैं? <span className="text-red-500">*</span>
            </label>
            <textarea
              required
              className="rounded-lg p-3 w-full outline-none h-20"
              placeholder="Explain your reasons for applying for internship"
              style={{
                border: `1.5px solid ${COLORS.accent}`,
                color: COLORS.textPrimary
              }}
            />
          </div>
          {/* What are your skills */}
          <div>
            <label className="block font-semibold mb-1" style={{ color: COLORS.textPrimary }}>
              आपकी skills क्या हैं? <span className="text-red-500">*</span>
            </label>
            <textarea
              required
              className="rounded-lg p-3 w-full outline-none h-20"
              placeholder="List your skills"
              style={{
                border: `1.5px solid ${COLORS.accent}`,
                color: COLORS.textPrimary
              }}
            />
          </div>
          {/* Upload Resume */}
          <div>
            <label className="block font-semibold mb-1" style={{ color: COLORS.textPrimary }}>
              Upload Resume <span className="text-red-500">*</span>
            </label>
            <span className="block text-xs mb-1" style={{ color: COLORS.textSecondary }}>Upload your resume (PDF only, Max 1 file).</span>
            <input
              required
              type="file"
              accept=".pdf"
              className="rounded-lg p-2 w-full outline-none"
              style={{
                border: `1.5px solid ${COLORS.accent}`,
                color: COLORS.textPrimary,
                background: COLORS.surface,
              }}
            />
            <span className="block text-xs mt-1" style={{ color: COLORS.textSecondary }}>Upload 1 supported file: PDF. Max 10 MB.</span>
          </div>
          {/* Upload Passport Size Photo */}
          <div>
            <label className="block font-semibold mb-1" style={{ color: COLORS.textPrimary }}>
              Upload Passport Size Photo <span className="text-red-500">*</span>
            </label>
            <span className="block text-xs mb-1" style={{ color: COLORS.textSecondary }}>Upload a recent passport size photo</span>
            <input
              required
              type="file"
              accept="image/*"
              className="rounded-lg p-2 w-full outline-none"
              style={{
                border: `1.5px solid ${COLORS.accent}`,
                color: COLORS.textPrimary,
                background: COLORS.surface,
              }}
            />
            <span className="block text-xs mt-1" style={{ color: COLORS.textSecondary }}>Upload 1 supported file: image. Max 10 MB.</span>
          </div>
          {/* Upload ID Proof */}
          <div>
            <label className="block font-semibold mb-1" style={{ color: COLORS.textPrimary }}>
              Upload ID Proof (Aadhaar Card / College Id) <span className="text-red-500">*</span>
            </label>
            <span className="block text-xs mb-1" style={{ color: COLORS.textSecondary }}>
              Upload any one valid ID proof (Aadhaar Card or College ID). Ensure the document is clear and readable.
            </span>
            <input
              required
              type="file"
              accept=".pdf,image/*"
              className="rounded-lg p-2 w-full outline-none"
              style={{
                border: `1.5px solid ${COLORS.accent}`,
                color: COLORS.textPrimary,
                background: COLORS.surface,
              }}
            />
            <span className="block text-xs mt-1" style={{ color: COLORS.textSecondary }}>Upload 1 supported file: PDF or image. Max 10 MB.</span>
          </div>
          {/* Declaration/Agreement */}
          <div
            className="flex items-start gap-2 text-sm"
            style={{ color: COLORS.primary }}
          >
            <input
              type="checkbox"
              id="declare"
              required
              className="mt-1 accent-orange-600"
              style={{
                accentColor: COLORS.primary
              }}
            />
            <label htmlFor="declare" className="flex flex-col">
              <span>I hereby declare that the information provided is true and correct.</span>
              <span>I agree to follow all rules and regulations of the organization during the internship.</span>
              <span className="text-red-500">*</span>
            </label>
          </div>
          {/* Submit */}
          <button
            type="submit"
            className="w-full py-3 rounded-lg font-semibold transition mt-2"
            style={{
              backgroundColor: COLORS.primary,
              color: COLORS.surface
            }}
            onMouseOver={e => (e.currentTarget.style.backgroundColor = COLORS.secondary)}
            onMouseOut={e => (e.currentTarget.style.backgroundColor = COLORS.primary)}
          >
            Submit Registration
          </button>
        </form>
      </div>
    </section>
  )
}

export default InternshiForm